import {
  Calculator as CalculatorUi,
  CALCULATOR_TYPE,
  CalculatorProps as CalculatorUiProps,
  CalculatorType,
  CATALOG_CONFIG,
  getFetcherFn,
  State,
} from '@sbercloud/uikit-product-calculator';
import {
  LAYOUT_TYPE,
  MatchMedia,
  useMatchMedia,
} from '@sbercloud/uikit-product-utils';
import cn from 'classnames';
import { useState } from 'react';
import { backendHost } from 'src/global';

import { Form, PortalModal } from './components';
import { useActions } from './hooks';
import styles from './styles.module.scss';

const fetcherFn = getFetcherFn(backendHost);

const matchMediaToLayoutType = ({
  isMobile,
  isSmallDesktop,
  isTablet,
}: MatchMedia) => {
  if (isMobile) {
    return LAYOUT_TYPE.Mobile;
  }

  if (isTablet) {
    return LAYOUT_TYPE.Tablet;
  }

  if (isSmallDesktop) {
    return LAYOUT_TYPE.DesktopSmall;
  }

  return LAYOUT_TYPE.Desktop;
};

export type CalculatorProps = {
  className?: string;
  iniState?: CalculatorUiProps['iniState'];
  initialActiveProduct?: CalculatorUiProps['initialActiveProduct'];
  calculatorType?: CalculatorType;
};

function kebabToCamel(kebabStr?: string): string | undefined {
  if (!kebabStr) {
    return undefined;
  }

  if (kebabStr === 'cloudContainerKubernetes') {
    return 'cloudContainerEngine';
  }

  const parts = kebabStr.split('-');

  return (
    parts[0] +
    parts
      .slice(1)
      .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
      .join('')
  );
}

export function Calculator({
  className,
  iniState,
  initialActiveProduct,
  calculatorType = CALCULATOR_TYPE.Main,
}: CalculatorProps) {
  const matchMedia = useMatchMedia();

  const layoutType = matchMediaToLayoutType(matchMedia);
  const {
    onShareClick,
    onCatalogOpen,
    onConnectClick,
    onDownloadFileClick,
    onProductSelect,
    onProductDelete,
    onPlatformSelect,
    onRequestConsultationClick,
    onStartClick,
  } = useActions();

  const [open, setOpen] = useState<boolean>(false);
  const [state, setState] = useState<State | null>(null);

  const handleOnRequestConsultationClick = (state: State) => {
    onRequestConsultationClick?.(state);
    setOpen(true);
    setState(state);
  };

  const handleClose = () => {
    setOpen(false);
    setState(null);
  };

  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={styles.container}>
        <CalculatorUi
          config={CATALOG_CONFIG}
          layoutType={layoutType}
          calculatorType={calculatorType}
          bgImage="/webp/calculatorOnboardingBackground.webp"
          fetcherFn={fetcherFn}
          actions={{
            onDownloadFileClick,
            onShareClick,
            onRequestConsultationClick: handleOnRequestConsultationClick,
            onCatalogOpen,
            onConnectClick,
            onProductSelect,
            onPlatformSelect,
            onStartClick,
            onProductDelete,
          }}
          initialActiveProduct={kebabToCamel(initialActiveProduct)}
          iniState={iniState}
        />

        {open && state && (
          <PortalModal
            onClickForClose={handleClose}
            className={styles.portalOverlay}
          >
            <Form state={state} modalClose={handleClose} />
          </PortalModal>
        )}

        <div id="portal-calc" />
      </div>
    </div>
  );
}
